/**
 * One centered IconSpinner used everywhere in the dashboard for
 * first-load states — matches the Conversations pages so the
 * "loading…" treatment is identical across every page.
 *
 *   {loading && !loaded ? <DashboardLoader /> : <RealContent />}
 *
 * Sized + coloured once here so individual pages don't drift on
 * stroke width / colour / centering.
 */

import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { IconSpinner } from '../../components';

import css from './DashboardLoader.module.css';

const DashboardLoader = ({ className }) => (
  <div className={classNames(css.root, className)} role="status" aria-live="polite">
    <IconSpinner className={css.spinner} />
  </div>
);

DashboardLoader.defaultProps = { className: null };
DashboardLoader.propTypes = { className: string };

export default DashboardLoader;
